import { Phone } from 'lucide-react';
import { Badge } from '@/shared/ui';
import styles from './StatusPills.module.css';

interface StatusPillsProps {
  fill: 'filled' | 'partially-filled' | null;
  source: 'AI' | 'phone' | null;
  confirmed: boolean;
}

export function StatusPills({ fill, source, confirmed }: StatusPillsProps) {
  return (
    <div className={styles.pills}>
      {fill && !confirmed && (
        <Badge variant={fill === 'filled' ? 'neutral' : 'warning'}>
          <span className={styles.badgeContent}>
            {source === 'phone' && <Phone size={10} aria-hidden />}
            {fill === 'filled' ? 'filled' : 'partial'}
            {source === 'phone' && ' · phone'}
          </span>
        </Badge>
      )}
      {confirmed && <Badge variant="primary">confirmed</Badge>}
    </div>
  );
}
